import Request from './request'

const Simcard = {
  getPagesSimcards (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard/pages', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardList (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard/list/' + params.page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getSimcardHistoryAction(id, callback) {
    Request.post('simcard/actions-log/' + id).then(callback).catch(this.bad_answer)
  },
  getSimcardTraffic (id, params, callback) {
    Request.get('simcard/traffic/' + id, params).then(callback).catch(this.bad_answer)
  },
  getSimcardDeviceHistory(id, callback) {
    Request.get('simcard/device-history/' + id).then(callback).catch(this.bad_answer)
  },
  putSimcardDevices(id, params, callback) {
    Request.put('simcard/update/'+ id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },

  getSimcardDevicesNew(imsi, callback, bad_answer) {
    Request.get('simcard/view/'+ imsi).then(callback).catch(bad_answer)
  },

}
export default Simcard
